function truncateText(str, start, end) {
    return str.substr(0, start || 10) + "..." + str.substr(str.length - (end || 10), str.length)
}

export { truncateText }
